<template>
    <div id="BlogDetail">
        <BigTitle />
        <div class="row ">
            <div class="col-10 offset-1">
                <div class="shadow rounded bg-light d-flex flex-column blog-container">
                    <b-button class="mb-3" v-on:click='goback'>返回</b-button>
                    <H4>{{blog.title}}</H4>
                    <p class="blog-cate">
                        <CategoryItem v-for="(item, index) in blog.categoryNames" v-bind:key="index" v-bind:name="item" v-bind:onlyShow="true"/>
                    </p>
                    <p class="text-muted blog-time">更新于：{{blog.updateTimeStr}}</p>
                    <p class="text-muted blog-count">被访问：{{blog.visitCount}} 次</p>
                    <!-- <ul class="nav nav-tabs">
                        <div class="dropdown-divider"></div>
                    </ul> -->
                    <div class="markdown-body" v-html="blog.renderContext" v-if="blog.type == 1">
                        
                    </div>
                    <div v-if="blog.type == 2">
                        <b-embed
                        type="iframe"
                        aspect="16by9"
                        v-bind:src="blog.mdContext"
                        allowfullscreen
                        ></b-embed>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import  CategoryItem from '../components/CategoryItem'
import BigTitle from '../components/BigTitle'
//import SideBar from '../components/SideBar'
import axios from 'axios'
// import GlobalConstant from '../constants/GlobalConstant'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

export default {
    'name': 'BlogDetail',

    data() {
        return { 
            card : "",
            blog: {}
        }
    },

    components:{
        CategoryItem,
        BigTitle
    },

    mounted: function(){
        console.log("mounted!!!!");
        this.card = this.$route.params.pathMatch;
        this.setDetail();
    },

    methods : {
        setDetail: function(){
            var _this = this;
            axios.get('/api/blog/' + this.card)
                .then(function(response){
                    console.log(response);
                    var res = response.data;
                    if(res.code == 1){
                        console.log(res.data);
                        _this.$set(_this, "blog", res.data);
                    }
                })
                .catch(function(error){
                    console.log(error);
                })   
        },
        goback : function(){
            if(document.referrer){
                window.location.href = document.referrer;
            }else{
                window.location.href = '/';
            }
        }
    }
}
</script>

<style scoped>
    .blog-container{
        padding: 2rem 2rem 2rem 2rem;
    }
    .blog-time{
        font-size: 0.75em;
    }
    .blog-count{
        font-size: 0.75em;
    }

    @import url("https://cdnjs.cloudflare.com/ajax/libs/github-markdown-css/2.9.0/github-markdown.min.css");
</style>